import React, { useEffect, useState } from 'react'

import { Helmet } from 'react-helmet'

import './page.css'

function DrupalContentPage() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        // Fetch content from Drupal
        fetch('https://your-drupal-site.com/api/content')
            .then(response => response.json())
            .then(data => setContent(data))
            .catch(error => console.error('Error fetching Drupal content:', error));
    }, []);

    return (
        <div>
            <h1>Drupal Content</h1>
            {content ? (
                <div>
                    {/* Render your content here */}
                    <h2>{content.title}</h2>
                    <p>{content.body}</p>
                </div>
            ) : (
                <p>Loading content...</p>
            )}
        </div>
    );
}

export default DrupalContentPage
